const services = [
  {
    icon: "ri-time-line",
    title: "Emergency Passport",
    description: "Flying in 24–72 hours from Hinesville or Fort Stewart? Our emergency expedited passport service is designed for urgent, last-minute travel from coastal Georgia. We prioritize your application and submit directly via reserved agency slots.",
    bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
    badge: "Same-Day Available",
    link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
  },
  {
    icon: "ri-refresh-line",
    title: "Passport Renewal",
    description: "Already have a U.S. passport? We help Hinesville and Liberty County travelers renew fast and avoid delays — no agency visit required for most renewals. Our expedited passport renewal gets you back on the road quickly.",
    bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
    badge: "Most Common",
    link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
  },
  {
    icon: "ri-file-add-line",
    title: "New Passport",
    description: "First-time applicants in Hinesville typically require an in-person acceptance clerk visit. We guide you through every step of the expedited new passport process.",
    bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
  },
  {
    icon: "ri-search-eye-line",
    title: "Lost or Stolen Passport",
    description: "Replacements often require additional forms. We guide you through exactly what's needed to avoid costly mistakes and delays on your expedited lost passport replacement.",
    bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    description: "Minors (15 and under) in Hinesville require parental participation and an in-person acceptance step. We provide clear instructions and checklists for expedited child passports.",
    bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change",
    description: "After marriage, divorce, or a legal name change in Hinesville — we assist with corrected passports and data corrections through our expedited name change service.",
    bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=name-change",
  },
  {
    icon: "ri-book-2-line",
    title: "Second Passport",
    description: "Need a second passport for frequent travel? We handle second passport issuance efficiently with expedited processing for Hinesville and coastal Georgia travelers.",
    bullets: ["Frequent traveler solutions", "Valid alongside existing passport", "Expedited processing"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
  },
  {
    icon: "ri-error-warning-line",
    title: "Damaged Passport",
    description: "Replacing a significantly damaged or water-damaged passport in coastal Georgia? We guide you through the replacement process with clear instructions.",
    bullets: ["Damaged passport replacement", "Documentation guidance", "Expedited processing"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
  },
  {
    icon: "ri-bank-card-line",
    title: "Passport Card",
    description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
    bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
  },
];

export default function HinesvilleServicesSection() {
  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Services We Provide for Hinesville Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you need an emergency passport, a renewal, a first-time passport, or a replacement — Fast Passport Center handles it with reserved courier submission availability for Hinesville, Fort Stewart, Richmond Hill, and coastal Georgia residents.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              {service.badge && (
                <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {service.badge}
                </span>
              )}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${service.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="space-y-1.5 mb-6 flex-1">
                {service.bullets.map((b, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href={service.link}
                className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap"
              >
                Get Started <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}